import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Langue } from '@zakat/shared';

interface PreferencesState {
  /** Mode économie de data : pas d'autoplay vidéo, images basse qualité. */
  dataSaver: boolean;
  language: Langue;
  installDismissedAt: number;
  setDataSaver(value: boolean): void;
  setLanguage(lang: Langue): void;
  dismissInstall(): void;
}

const prefersSaveData = typeof navigator !== 'undefined' && Boolean((navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData);

export const usePreferences = create<PreferencesState>()(
  persist(
    (set) => ({
      dataSaver: prefersSaveData,
      language: 'fr',
      installDismissedAt: 0,
      setDataSaver: (dataSaver) => set({ dataSaver }),
      setLanguage: (language) => set({ language }),
      dismissInstall: () => set({ installDismissedAt: Date.now() }),
    }),
    { name: 'zl-preferences' },
  ),
);
